import {Notyf} from 'notyf';
import 'notyf/notyf.min.css';

const notyf = new Notyf({
    duration: 3000,
    position: {
        y: 'top'
    },
    dismissible: true,
    types: [
        {
            type: 'info',
            background: '#1E90FF',
            duration: 3000,
            dismissible: true
        },
        {
            type: 'alert',
            background: '#07097c',
            duration: 2000,
            dismissible: true
        }
    ]

});

export function displaySuccess(message) {
    notyf.success(message);
}

export function displayError(message) {
    notyf.error(message);
}

export function displayInfo(message) {
    notyf.open({ type: 'info', message: message });
}

export function displayAlert(message) {
    notyf.open({ type: 'alert', message: message });
}
